import React from 'react';
import { Col, Row, Button } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';

const SupplyByCenterSection = ({ filters, rightCanvasBtn }) => {
	return (
		<Row className='align-items-center'>
			<Col xs='auto' className='ms-auto'>
				<Button color='secondary' outline onClick={rightCanvasBtn}>
					<FeatherIcon icon='filter' size={16} className='me-1' />
					Filtros
				</Button>
			</Col>
		</Row>
	);
};

export default SupplyByCenterSection;
